import DocumentTypeEntity from '../entities/DocumentType.Entity';
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export default function getTenantDocumentTypes(serviceId: number, abortSignal: AbortSignal): Promise<Array<DocumentTypeEntity>> {    
    return apiGet<Array<DocumentTypeEntity>>('/document-types',abortSignal, "serviceId="+serviceId+"&belongto=Tenant");
}
